import { render } from "./IqCard.vue?vue&type=template&id=a8b59dca"
import script from "./IqCard.vue?vue&type=script&lang=js"
export * from "./IqCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__